import Header from "../componentes/Header";

function Admin() {
    return(
        <>
            <Header/>
        </>
    )
}

export default Admin;